import { FIELD_TYPES } from "@hyro-components/fields/utils";

export const COLUMNS = {
  timestamp: { id: "timestamp", label: "Time" },
  assistantId: { id: "assistantId", label: "Agent ID" },
  pageName: { id: "pageName", label: "Page name" },
  actionName: { id: "actionName", label: "Action name" },
  userEmail: { id: "userEmail", label: "User" },
  statusCode: { id: "statusCode", label: "Status Code" }
};

export const SEARCH_COLUMNS = Object.values(COLUMNS).map((column) => column.id);

export const FILTERS = Object.values(COLUMNS).map((column) => ({
  key: column.id,
  label: column.label,
  type: FIELD_TYPES.TEXT
}));
